<div class="container">
  <div class="title">{{ title }}</div>

  <div *ngIf="formGroup" class="body" fxLayout="column" fxLayoutAlign="start stretch">
    <div class="container-details" fxLayout="row" fxLayoutAlign="space-between start">
      <!-- <div class="container-calendar" [ngClass]="{ 'full-width': isGardes }"> -->
      <div class="container-calendar">
        <div class="mg-b-15 no-click" fxLayout="row" fxLayoutAlign="space-between center">
          <app-date-input
            class="width-48"
            [isTodayMinDate]="true"
            label="Date de début"
            [formCtrl]="formGroup.get('startDate')! | formControl"
            [fromMon2Fri]="false"
            [isOnlyMonday]="true"
            placeholder="JJ/MM/AAAA"
            (click)="$event.stopPropagation(); $event.preventDefault()"
          ></app-date-input>

          <app-date-input
            class="width-48"
            [isNextWeekMinDate]="true"
            label="Date de fin"
            [formCtrl]="formGroup.get('endDate')! | formControl"
            [fromMon2Fri]="false"
            [isOnlyFriday]="true"
            placeholder="JJ/MM/AAAA"
            [minDate]="minDate"
            [maxDate]="maxDate"
            (click)="$event.stopPropagation(); $event.preventDefault()"
          ></app-date-input>
        </div>

        <ngx-daterangepicker-bootstrap
          [autoApply]="true"
          [locale]="dateLocale"
          [showWeekNumbers]="true"
          (chosenDate)="chosenDate($event)"
          [minDate]="monday.toISOString()"
        >
        </ngx-daterangepicker-bootstrap>
      </div>

      <div class="container-week-start default-select width-28" fxLayout="column" fxLayoutAlign="start start">
        <div class="select-label">Commencer par semaine</div>
        <div class="select-label-guideline">Par quelle semaine du modèle souhaitez-vous commencer la génération?</div>
        <div>
          <div *ngFor="let weekNumber of availableWeeks" style="font-size: large; padding-bottom: 8px">
            <label>
              <input
                type="radio"
                [value]="weekNumber"
                [(ngModel)]="startWeek"
                (ngModelChange)="handleSelectStartWeek($event)"
                name="startWeek"
              />
              {{ weekNumber }}
              <span *ngIf="data.comments && data.comments[weekNumber - 1]">
                ({{ data.comments[weekNumber - 1] }})
              </span>
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="rooms" class="profiles-box width-28 default-select">
        <div class="select-label">Liste des salles concernées</div>
        <div *ngFor="let room of roomsFormElements; let i = index" class="profile-box">
          <mat-checkbox [checked]="room.isChecked" (change)="onRoomChange($event, room)">
            <span class="truncate-label">{{ room.label }}</span>
          </mat-checkbox>
        </div>
      </div>

      <div *ngIf="isProfile" class="profiles-box width-28 default-select">
        <div class="select-label">Liste des profils concernés</div>
        <div *ngFor="let profile of profilesFormElements; let i = index" class="profile-box">
          <mat-checkbox [checked]="profile.isChecked" (change)="onProfileChange($event, profile)">
            <span class="truncate-label">{{ profile.label }}</span>
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>

  <mat-slide-toggle
    (change)="toggleAnesthNeeds()"
    [checked]="linkAnesthNeeds"
    *ngIf="rooms && accessOptions?.showAssociateAnesthNeeds"
  >
    Associer les besoins d'anesthésie</mat-slide-toggle
  >

  <div *ngIf="formGroup && isGardes && needs && nightGenerationTypes.length > 1">
    <app-checkbox-group
      label="Besoins pour"
      layout="row"
      [elements]="nightGenerationTypes"
      [formCtrl]="formGroup.get('generationTypes')! | formControl"
    >
    </app-checkbox-group>
  </div>

  <div *ngIf="withGroup && formGroup">
    <app-checkbox-group
      *ngIf="formGroup && generationTypes && generationTypes.length > 1"
      label="Besoins pour"
      layout="row"
      [elements]="generationTypes"
      [formCtrl]="formGroup.get('generationTypes')! | formControl"
    >
    </app-checkbox-group>

    <div class="mg-t-15">
      <app-checkbox-group
        *ngIf="
          positions &&
          accessOptionsHaveAnesth &&
          !(accessOptions?.seniority?.length === 1 && accessOptions?.seniority?.[0] === 'Interne')
        "
        label="Positions"
        layout="row"
        [elements]="positions"
        [formCtrl]="formGroup.get('positions')! | formControl"
        style="margin-top: 12px"
      >
      </app-checkbox-group>
    </div>
  </div>

  <div class="buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-button (click)="close()" text="Annuler" btnType="text"></app-button>
    <app-button
      [disabled]="!formGroup?.valid"
      (click)="generate()"
      btnType="primary"
      color="primary"
      text="{{ generateBtnTitle }}"
    ></app-button>
  </div>
</div>

<ng-template #loading>
  <div class="spinnerContainer" fxLayoutAlign="center center">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
